// Theme colors for Afrotech Group website
export const theme = {
  colors: {
    primary: '#121619', // Dark charcoal for backgrounds
    secondary: '#D4AF37', // Gold for highlights and accents
    tertiary: '#B87333', // Deep bronze for hover effects
    accent: '#007BFF', // Electric blue for graphs/charts
    text: {
      primary: '#FFFFFF', // White text on dark backgrounds
      secondary: '#121619', // Dark text on light backgrounds
      accent: '#D4AF37', // Gold text for emphasis
      muted: 'rgba(255, 255, 255, 0.7)', // Muted text for less emphasis
    },
    background: {
      light: '#F8F9FA',
      card: '#FFFFFF',
      dark: '#121619',
      overlay: 'rgba(18, 22, 25, 0.85)', // Semi-transparent overlay
    },
    gradient: {
      primary: 'linear-gradient(135deg, #121619 0%, #1E2328 100%)',
      secondary: 'linear-gradient(135deg, #D4AF37 0%, #B87333 100%)',
      accent: 'linear-gradient(135deg, #007BFF 0%, #00C6FF 100%)',
      light: 'linear-gradient(135deg, #121619 0%, #1E2328 100%)',
      dark: 'linear-gradient(135deg, #0A0C0E 0%, #121619 100%)',
      card: 'linear-gradient(135deg, rgba(30, 35, 40, 0.4) 0%, rgba(18, 22, 25, 0.4) 100%)',
      gold: 'linear-gradient(135deg, #D4AF37 0%, #B87333 100%)',
      button: 'linear-gradient(135deg, #D4AF37 0%, #B87333 100%)',
      glow: 'radial-gradient(circle at center, rgba(212, 175, 55, 0.15) 0%, rgba(0, 0, 0, 0) 70%)',
      blueGlow: 'radial-gradient(circle at center, rgba(0, 123, 255, 0.15) 0%, rgba(0, 0, 0, 0) 70%)',
    },
    border: {
      light: 'rgba(255, 255, 255, 0.1)',
      gold: 'rgba(212, 175, 55, 0.3)',
      accent: 'rgba(0, 123, 255, 0.3)',
      hover: 'rgba(212, 175, 55, 0.5)',
    },
  },
  fonts: {
    primary: "'Poppins', sans-serif",
    secondary: "'Roboto', sans-serif",
    tertiary: "'Inter', sans-serif",
  },
  typography: {
    lineHeight: {
      body: 1.6,
      heading: 1.2,
      tight: 1.1,
      relaxed: 1.8,
    },
    fontWeight: {
      light: 300,
      regular: 400,
      medium: 500,
      semiBold: 600,
      bold: 700,
    },
    fontSize: {
      xs: '0.75rem',    // 12px
      sm: '0.875rem',   // 14px
      base: '1rem',     // 16px
      md: '1.125rem',   // 18px
      lg: '1.25rem',    // 20px
      xl: '1.5rem',     // 24px
      '2xl': '1.875rem', // 30px
      '3xl': '2.25rem',  // 36px
      '4xl': '3rem',     // 48px
      '5xl': '3.75rem',  // 60px
    },
    letterSpacing: {
      tight: '-0.025em',
      normal: '0',
      wide: '0.025em',
      wider: '0.05em',
    },
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
  },
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '12px',
    pill: '50px',
  },
  shadows: {
    small: '0 2px 4px rgba(0, 0, 0, 0.1)',
    medium: '0 4px 8px rgba(0, 0, 0, 0.12)',
    large: '0 8px 16px rgba(0, 0, 0, 0.14)',
    card: '0 10px 20px rgba(0, 0, 0, 0.15), 0 3px 6px rgba(0, 0, 0, 0.1)',
    focus: '0 0 0 3px rgba(212, 175, 55, 0.4)',
    gold: '0 4px 12px rgba(212, 175, 55, 0.15)',
    blue: '0 4px 12px rgba(0, 123, 255, 0.15)',
    inner: 'inset 0 2px 4px rgba(0, 0, 0, 0.06)',
    text: '0 2px 4px rgba(0, 0, 0, 0.3)',
    hover: '0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22)',
    button: '0 4px 6px rgba(0, 0, 0, 0.1)',
    buttonHover: '0 6px 12px rgba(0, 0, 0, 0.15)',
  },
  transitions: {
    fast: { duration: 0.2, ease: 'easeInOut' },
    medium: { duration: 0.3, ease: 'easeInOut' },
    slow: { duration: 0.5, ease: 'easeInOut' },
    bounce: { 
      type: 'spring',
      stiffness: 500,
      damping: 20
    },
    spring: {
      type: 'spring',
      stiffness: 300,
      damping: 20
    },
    easeOut: { duration: 0.4, ease: [0.215, 0.61, 0.355, 1] },
    easeIn: { duration: 0.4, ease: [0.55, 0.055, 0.675, 0.19] },
  },
  breakpoints: {
    mobile: '768px',
    tablet: '1024px',
    desktop: '1280px',
  },
  zIndex: {
    navbar: 1000,
    modal: 2000,
    tooltip: 3000,
  },
};

export default theme;
